import select from 'dom-select';

export const GlobalHeader = (el) => {
  const ui = {
    el,
    body: select('body'),
    pageshell: select('.pageshell'),
    searchInput: select('.global-nav__search .input'),
    globalNav: select('.global-nav'),
    toggles: select.all('.nav-item', document),
  };

  const closeAllSubnavs = () => {
    ui.toggles.forEach((toggle) => {
      toggle.removeAttribute('aria-expanded');
      ui.body.classList.remove('subnav-open');
    });
  }

  let headerHeight = ui.el.offsetHeight;

  const handleBodyScroll = () => {
    let lastScrollTop = 0;

    window.addEventListener("scroll", function(){ 
      let st = window.pageYOffset || document.documentElement.scrollTop; 

      if (st > lastScrollTop && ui.pageshell) {
        // down scroll code
        if (st > headerHeight) {
          ui.body.classList.add('scrolled-down');
          ui.body.classList.remove('scrolled-up');
          closeAllSubnavs();
        }
      } else {
         // up scroll code
          ui.body.classList.add('scrolled-up');
          ui.body.classList.remove('scrolled-down');

        if (st === 0) {
          ui.body.classList.remove('scrolled-down');
          ui.body.classList.remove('scrolled-up');
        }
      }
      // For Mobile or negative scrolling
      lastScrollTop = st <= 0 ? 0 : st;
    }, 
    false
    );
  }

  const addEvents = () => {
    handleBodyScroll();
  };

  const init = () => {
    addEvents();
  };

  init();
};

export default GlobalHeader;
